import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function VisionSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-primary-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-accent-400">{t('vision.title')}</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mt-2">{t('vision.subtitle')}</h2>
        </div>

        {/* President's Image + Quote */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            {/* President Image */}
            <div className="w-full md:w-auto flex-shrink-0">
              <div className="relative">
                <div className="w-48 h-48 md:w-56 md:h-56 mx-auto rounded-2xl overflow-hidden border-2 border-accent-500/30">
                  <img
                    src="https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/c7bdcb3ed87590029d6e0640a43364dd.jpeg"
                    alt="Baby Olivier Pandja — Président du Tennis Club de Douala"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -bottom-2 -right-2 w-16 h-16 border-2 border-accent-500/20 rounded-2xl hidden md:block"></div>
                <div className="absolute -top-2 -left-2 w-12 h-12 border-2 border-accent-500/10 rounded-2xl hidden md:block"></div>
              </div>
              <p className="text-center mt-4 font-heading text-lg text-background-50 font-semibold">Baby Olivier Pandja</p>
              <p className="text-center text-sm text-accent-400 tracking-wide uppercase">{t('vision.subtitle')}</p>
            </div>

            {/* Quote */}
            <div className="flex-1 text-center md:text-left">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/20 text-accent-400 mb-5 mx-auto md:mx-0">
                <i className="ri-double-quotes-l text-xl"></i>
              </div>
              <blockquote className="text-base md:text-lg text-background-50/80 italic leading-relaxed font-light">
                "{t('vision.quote')}"
              </blockquote>
            </div>
          </div>
        </div>

        {/* Vision Points */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {[1, 2, 3, 4, 5].map((n) => (
            <div
              key={n}
              className="bg-background-50/5 border border-background-50/10 rounded-2xl p-6 backdrop-blur-sm transition-all duration-300 hover:bg-background-50/10 hover:border-accent-400/30"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/20 text-accent-400 mb-4">
                <i className="ri-check-double-line text-lg"></i>
              </div>
              <p className="text-sm md:text-base text-background-50/90 leading-relaxed">{t(`vision.point${n}`)}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 font-semibold text-sm rounded-full hover:bg-accent-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            {t('vision.cta')}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
